module.exports = __webpack_public_path__ + "static/media/white@2x.006c2abd.png";